import { AssureEditionEnum, HostingOptionEnum } from "@/app/api/battery-portal-api";
import { isLicenseAllowed } from "@/app/utils/license-helper";
function updateVisibility(el, rule) {
    el.style.display = isLicenseAllowed(rule) ? "" : "none";
}
/** Flexible directive: v-license="{ hostingOption: ..., minimumEdition: ... }" */
export const vLicense = {
    mounted(el, binding) {
        updateVisibility(el, binding.value);
    },
    updated(el, binding) {
        updateVisibility(el, binding.value);
    }
};
/** Shorthand: v-cloud-only */
export const vCloudOnly = {
    mounted(el) {
        updateVisibility(el, { hostingOption: HostingOptionEnum.PowershieldCloud });
    }
};
/** Shorthand: v-onprem-only */
export const vOnPremOnly = {
    mounted(el) {
        updateVisibility(el, { hostingOption: HostingOptionEnum.OnPrem });
    }
};
/** Shorthand: v-standard-or-higher */
export const vStandardOrHigher = {
    mounted(el) {
        updateVisibility(el, { minimumEdition: AssureEditionEnum.OnPremStandard });
    }
};
/** Shorthand: v-premium-only */
export const vPremiumOnly = {
    mounted(el) {
        updateVisibility(el, { minimumEdition: AssureEditionEnum.OnPremPremium });
    }
};
